import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  MOB_ICONS,
  queryParam,
  upperCase,
  useQuery,
  yearBySem,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const DayWiseMarkedAndPending = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [generalData, setGeneralData] = useState([]);

  const [selectedDate, setSelectedDate] = useState([]);

  const params = useParams();
  let searchParams = queryParam(useQuery());

  useEffect(() => {
    if (dataList.length < 1) loadData();
  }, []);

  const loadData = () => {
    context.setLoader(true);
    setHoliday([]);
    setDataList([]);
    const form = new FormData();
    form.append("attendance_date", props.dayOrder.attendance_date);
    form.append("teacher", context.user.id);
    form.append("acyear", props.dayOrder.college_year); //momentDate(new Date(), "YYYY-MM-DD"));
    axios.post(ServiceUrl.MOB.MY_HOSTEL_MARKLIST, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
        if (res["data"].data) setHoliday(res["data"].data);
      }
      context.setLoader(false);
    });
  };

  const getIcon = (item, defaultTrue = false) => {
    if (defaultTrue) return MOB_ICONS.CHECKMARK_256;

    return item.attendace_marked_count > 0
      ? MOB_ICONS.CHECKMARK_256
      : MOB_ICONS.TIMEMANAGEMENT_256;
  };

  const linkClick = (toUrl, val) => {
    navigate(toUrl + "?category=" + val);
  };
  return (
    <>
      <section className="pt-2 pb-0">
        <div className="row">
          <div className="col-12">
            <div className="list-group">
              {dataList.map((item) => (
                <a
                  className="list-group-item d-flex justify-content-between align-items-center border-0 "
                  onClick={(e) =>
                    linkClick(
                      `/staff/app/hostel-att-report/`,
                      item.category_id +
                        "&attendance_date=" +
                        item.attendance_date +
                        "&floor_id=" +
                        item.floor_id +
                        "&acyear=" +
                        item.college_year +
                        "&from=marklist"
                    )
                  }
                >
                  <span className="noti-icons">
                    <img
                      src={getIcon(item)}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30px", height: "30px" }}
                    />
                  </span>
                  <div className="noti-info">
                    <h6 className="mb-0">{item.attendence_name}</h6>
                    <span>
                      {item.floor_name} <br />{" "}
                      <span className="bg-blue-50 text-info">
                        {" "}
                        Total Students: <b>{item.count}</b>
                      </span>
                    </span>
                  </div>
                  <span className="float-end bg-red-50 text-danger px-1 rounded-circle">{`${item.attendance_date}`}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default DayWiseMarkedAndPending;
